export function replaceNewlinesWithBr(str: string) {
    return str.replace(/(\\r\\n|\\r|\\n)/g, '<br/>');
}
